import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { HeaderService } from '../../service/header.service';
import { CustomTokenClaims, IUser } from './../../auth/interfaces';
import { SpinnerService } from 'src/app/service/spinner.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})

export class HeaderComponent implements OnDestroy, OnInit {

  private subscriptionList: Subscription[] = [];
  public userData: IUser | null = null;
  public userIsAdmin$: Subject<boolean> = new Subject<boolean>();
  public userHasRenavamAccess$: Subject<boolean> = new Subject<boolean>();
  public userHasRenaveAccess$: Subject<boolean> = new Subject<boolean>();
  
  loadingState = false;

  tokenClaims!: CustomTokenClaims | null;

  constructor( public authService: AuthService, private headerService: HeaderService, private spinnerService: SpinnerService )
  {
  }

  ngOnInit(): void {
    this.authService.userClaims$.subscribe((updatedClaims) => {
      this.tokenClaims = updatedClaims;
    });
  }

  entrar(): void {
    this.authService.login();
  }

  sair(): void {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.subscriptionList.forEach((subscription) => subscription.unsubscribe());
  }
}
